import gsap from 'gsap';
import $ from '../core/Dom';

export default el => {
    const dom = $(el);

    const words = dom.find('span').nodes;

    let interval = 0;

    const getRandomWord = () => {
        const available = words.filter(word => word.dataset.scrambling === undefined && word.offsetWidth > 0);
        return available[Math.floor(Math.random() * available.length)];
    };

    const randomBoolean = () => Math.random() >= 0.5;

    const scrambleRandomWord = () => {
        const word = getRandomWord();
        const textWidth = word.offsetWidth;
        word.dataset.scrambling = 'true';
        gsap.set(word, { width: textWidth});
        gsap.to(word, {
            duration: 3,
            ease:   'power2.inOut',
            scrambleText: {
                text: '{original}',
                chars: 'upperCase',
                speed: 1,
                // rightToLeft: randomBoolean()
            },
            onComplete: () => {
                delete word.dataset.scrambling;
                gsap.set(word, { width: null});
            }
        });
    };

    const stopScrambling = () => {
        if (interval) {
            clearInterval(interval);
        }
    };

    const startScrambling = () => {
        stopScrambling();
        interval = setInterval(scrambleRandomWord, 500);
    };

    const init = () => {
        startScrambling();
    };

    const destroy = () => {
        stopScrambling();
    };

    return {
        init,
        destroy
    };
};
